import React, { Component } from 'react';
import { Switch, Route, withRouter } from 'react-router-dom';
import ScrollToTop from './utils/ScrollToTop';

import Swal from 'sweetalert2';

import { connect } from 'react-redux';

import Help from './common_pages/help/index';
import NotFound404 from './common_pages/NotFound404';

import LayoutRoute from './utils/LayoutRoute';

// * Sub Pages Mobile
import Categories from "./common_pages/home/categories";
import UserMenu from "./common_pages/user/menu";

// * Search by location
import ListStates from "./common_pages/search-by-location/list-states";
import SearchResultsLocation from "./common_pages/search-by-location/results";

// * Parterns
import Partners from './common_pages/partners/list-partners';
import Partner from "./common_pages/partners/partner"

// * Offers
import Offer from "./common_pages/offer";
import Offers from "./common_pages/offers";
import MyActiveOffers from './common_pages/account/active-offers';

// * Rescue Code
import Rescue from './common_pages/rescue';

// * Search Results
import SearchPage from './common_pages/search';
import Results from './common_pages/results';
import Tracking from './services/Tracking';

// * Terms
import Terms from './common_pages/terms';
import TermsReadOnly from './common_pages/terms-readonly';
import UserTerms from './services/UserTerms';

const listOfCommonPages = [
    //"",
    "ajuda",
    "resultados",
    "termos-e-condicoes",
    "terms",
    "categories",
    "user-menu",
    "lista-estados",
    "resultados-localizacao",
    "parceiro",
    "parceiros",
    "oferta",
    "ofertas",
    "ofertas-ativas",
    "resgatar",
    "search",
    "termos"
]

class Routes extends Component {

    componentDidMount() {
        this.checkUserTerm();
    }

    checkUserTerm = async () => {
        const userTerms = new UserTerms();

        try {

            const response = await userTerms.checkUserTerms();
            const data = await response.data;

            const termsMessageResponse = (data.message.indexOf("Termos de uso atual já aceito pelo usuário") !== -1);
            
            if (this.props.location.pathname === '/termos-e-condicoes') {
                if (termsMessageResponse) {
                    Swal.fire({
                        title: 'Termos e Condições',
                        html: `<p>Termos de uso atual já aceito pelo usuário</p>`,
                        confirmButtonText: 'Ok, entendi',
                        icon: 'error',
                        allowOutsideClick: false,
                        onClose: () => this.props.history.push({ pathname: '/', search: this.props.history.location.search })
                    });
                    return false;
                }
            }

            if (data && data.type === 'success') {
                if (data.code !== 0 && data.code !== -1) {
                    //REDIRECT PARA TELA DE TERMOS
                    this.props.history.push({ pathname: '/termos-e-condicoes', search: this.props.history.location.search });
                }
            }

        } catch (error) {
            return null;
        }
    }


    componentDidUpdate(prevProps) {
        const tracking = new Tracking();
        if (this.props.location !== prevProps.location) {
            tracking.saveTracking({ url: this.props.history.location.pathname });

            if (this.props.location.pathname.indexOf('termos-e-condicoes') === -1) {
                this.checkUserTerm();
            }
        }
    }

    render() {
        const listPathnames = window.location.pathname.split('/');
        if (listOfCommonPages.indexOf(listPathnames[listPathnames.length - 1].replace(new RegExp('/', 'g'), '')) === -1) {

            try {
                let SiteRoutes = require(`./${this.props.website}/Routes`);
                return (
                    <ScrollToTop>
                        <SiteRoutes.default />
                    </ScrollToTop>
                );

            } catch (e) {
                return (<NotFound404 />)
            }

        } else {
            let layout = require(`./${this.props.website}/Layout`).default;

            return (
                <ScrollToTop>
                    <Switch>

                        <LayoutRoute layout={layout} exact path="/ajuda" component={Help} />

                        <LayoutRoute layout={layout} exact path="/resultados" component={Results} />
                        <LayoutRoute layout={layout} exact path="/termos-e-condicoes" component={Terms} />
                        <LayoutRoute layout={layout} exact path="/terms" component={TermsReadOnly} />
                        <LayoutRoute layout={layout} exact path="/categories" component={Categories} />
                        <LayoutRoute layout={layout} exact path="/user-menu" component={UserMenu} />
                        <LayoutRoute layout={layout} exact path="/lista-estados" component={ListStates} />
                        <LayoutRoute layout={layout} exact path="/resultados-localizacao" component={SearchResultsLocation} />
                        <LayoutRoute layout={layout} exact path="/parceiros" component={Partners} />
                        <LayoutRoute layout={layout} exact path="/parceiro" component={Partner} />
                        <LayoutRoute layout={layout} exact path="/ofertas" component={Offers} />
                        <LayoutRoute layout={layout} exact path="/oferta" component={Offer} />
                        <LayoutRoute layout={layout} exact path="/ofertas-ativas" component={MyActiveOffers} />
                        <LayoutRoute layout={layout} exact path="/resgatar" component={Rescue} />
                        <LayoutRoute layout={layout} exact path="/search" component={SearchPage} />

                        <Route path="*">
                            <NotFound404 />
                        </Route>

                    </Switch>
                </ScrollToTop>
            )
        }

    }
}

const mapStateToProps = (state) => {
    return {
        website: state.websiteReducer.website,
        site_properties: state.websiteReducer.site_properties
    };
}

export default withRouter(connect(mapStateToProps, {})(Routes));